import type { RouteRecordNormalized } from 'vue-router';
import { AppRouteRecordRaw } from './types';
import SYSTEM from './modules/system';
import USER from './modules/user';
import MEMBER from './modules/member';
import STATION from './modules/station';
import DASHBOARD from './modules/dashboard';
import VISUALIZATION from './modules/visualization';
import LIST from './modules/list';
import FORM from './modules/form';
import PROFILE from './modules/profile';
import RESULT from './modules/result';
import EXCEPTION from './modules/exception';
import CHARGING from './modules/charging';
import PARTNER from './modules/partner';
import ORDER from './modules/order';
import PROFIT from './modules/profit';
import BILLING from './modules/billing';
import HOMEPAGE from './modules/homePage';
import MEMBERCARD from './modules/memberCard';
import INVOICE from './modules/invoice';
import STATISTIC from './modules/statistic';
import THIRD_PARTY from './modules/third-party';
import PAYMENT from './modules/payment';
import INVESTOR from './modules/investor';

const modules = import.meta.glob('./modules/*.ts', { eager: true });
const externalModules = import.meta.glob('./externalModules/*.ts', {
  eager: true,
});

function formatModules(_modules: any, result: RouteRecordNormalized[]) {
  Object.keys(_modules).forEach((key) => {
    const defaultModule = _modules[key].default;
    if (!defaultModule) return;
    const moduleList = Array.isArray(defaultModule)
      ? [...defaultModule]
      : [defaultModule];
    result.push(...moduleList);
  });
  return result;
}

// 使用手动导入的方式定义路由
export const appRoutes: AppRouteRecordRaw[] = [
  DASHBOARD,
  VISUALIZATION,
  LIST,
  FORM,
  PROFILE,
  RESULT,
  EXCEPTION,
  USER,
  MEMBER,
  SYSTEM,
  STATION,
  CHARGING,
  PARTNER,
  ORDER,
  PROFIT,
  BILLING,
  HOMEPAGE,
  MEMBERCARD,
  INVOICE,
  STATISTIC,
  THIRD_PARTY,
  PAYMENT,
  INVESTOR,
];

export const appExternalRoutes: RouteRecordNormalized[] = formatModules(
  externalModules,
  []
);
